// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { toggleModal } from '../../storage/actions/modalsActions';
import { payForWorkOrders } from '../../storage/actions/workOrdersActions';
import prepareFilters from '../../utils/prepareFilters';

const BulkWorkOrderPay = ({
  modalState,
  toggleModal,
  selectedWorkOrders,
  payForWorkOrders,
  search,
  filters,
  profile,
}) => {
  const [requestData, setRequestData] = useState({});

  useEffect(() => {
    const newRequestData = modalState?.type?.mode === 'useFilters'
      ? {
        ...search,
        filters: prepareFilters(filters),
      }
      : { workOrdersId: selectedWorkOrders };
    setRequestData(newRequestData);
  }, [modalState?.type?.mode, search, filters, selectedWorkOrders]);

  const closeModal = () => {
    toggleModal(false, 'bulkWorkOrderPay');
  };

  const onSubmit = () => {
    payForWorkOrders(requestData);
  };

  if (!modalState.isOpen) return null;

  const title = `Mark ${
    modalState?.type?.mode === 'useFilters'
      ? 'all'
      : selectedWorkOrders?.length
  } work orders as Paid?`;

  return (
    <div
      className="modal_block dashboard-modal dashboard-modal--centered modal_import showed"
      role="presentation"
      onClick={closeModal}
    >
      <div
        className="modal_container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bulk-work-order-pay-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal_head">
          <div className="modal_title" id="bulk-work-order-pay-title">
            {title}
          </div>
          <button
            type="button"
            className="close_btn"
            aria-label="close"
            onClick={closeModal}
          >
            ×
          </button>
        </div>
        <div className="modal_body">
          {profile.userType !== 'superAdmin' && (
            <div className="modal_content">
              <p>
                This will only mark Work Orders as paid
                if they are set to Pay outside of the system.
              </p>
            </div>
          )}
        </div>
        <div className="modal_footer">
          <button
            type="button"
            className="dashboard-btn dashboard-btn--secondary"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            type="button"
            className="dashboard-btn dashboard-btn--primary"
            onClick={onSubmit}
          >
            Ok
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  modalState: state.modalState.bulkWorkOrderPay,
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
  filters: state.workOrder?.filters,
  search: state.workOrder?.searchData,
  profile: state.profile,
});

export default connect(mapStateToProps, { toggleModal, payForWorkOrders })(BulkWorkOrderPay);
